import { Container, Input, Button } from 'components/UIElements'
import React from 'react'
import PropTypes from 'prop-types'
import { PW_REQUIREMENTS } from 'utils/misc'
import '../../CreateUser/stylesheets/user.scss'

const ActivateUserPage = props => {
  return (
    <div className='create-user page'>
      <Container>
        <h3>
          Your email address has been confirmed. Please create your password.
        </h3>
        <p>Your password must contain:</p>
        <ul className='requirements'>
          {PW_REQUIREMENTS.map((req, idx) => {
            return <li key={idx}>{req}</li>
          })}
        </ul>
        <Input
          id='user-password'
          placeholder='enter password'
          label='Password'
          type='password'
          value={props.changePasswordState.password}
          onChange={value => props.updateNewPassword('password', value)}
        />
        <Input
          id='user-password-confirmation'
          placeholder='re-enter password'
          label='Confirm Password'
          type='password'
          value={props.changePasswordState.password_confirmation}
          onChange={value =>
            props.updateNewPassword('password_confirmation', value)
          }
        />
      </Container>
      <div className='button-container'>
        <Button
          content='Submit'
          onClick={() =>
            props.setNewPassword(props.changePasswordState, props.userToken)
          }
        />
      </div>
    </div>
  )
}

export default ActivateUserPage

ActivateUserPage.propTypes = {
  changePasswordState: PropTypes.object,
  setNewPassword: PropTypes.func,
  updateNewPassword: PropTypes.func,
  userToken: PropTypes.string
}
